(function () {
  "use strict";

  angular
    .module('trainerWebApp.services')
    .factory('compositeSearchData', compositeSearchData);

  function compositeSearchData() {

    var data = null;
    var searchItem = null;

    function setSearchData(name, id) {
      data = {
        name: name,
        id: id
      };
    }

    function clearSearchData() {
      data = null;
    }

    function getSearchData() {
      return data;
    }

    function setSearchItem(item) {
      searchItem = item;
    }

    function getSearchItem() {
      return searchItem;
    }

    function clearSearchItem() {
      searchItem = null;
    }


    return {
      setSearchData: setSearchData,
      clearSearchData: clearSearchData,
      getSearchData: getSearchData,
      setSearchItem: setSearchItem,
      getSearchItem: getSearchItem,
      clearSearchItem: clearSearchItem
    }
  }

})();
